export const RU = {

index:{
title_general: "Симулятор дайвинга",
que_hace_txt: "Что делает?",
objetivo: "Цель — не симулировать дайвинг, а совершенствовать реального дайвера.",
modelos_txt_1: "Модели",
instrumentos_txt: "Инструменты",
seguridad_txt: "Безопасность",

que_se_pierde: "Что теряется при обучении дайвингу без симуляции?",

teoria_de_perdida: `

        <span style="color:#dfbb73;font-size: 20px;">"Теория учит тому, что делать. Симуляция учит тому, зачем это делать"</span>

        <br><br>Без симуляции многие концепции остаются абстрактными. Студенты заучивают лимиты, процедуры и таблицы, но им трудно визуализировать, как их решения на самом деле влияют на поглощение газов, декомпрессию, воздействие кислорода и безопасность погружения.
        <br><br>Симуляция превращает невидимые процессы в визуальный и интерактивный опыт. Она позволяет моделировать сценарии, анализировать последствия и понимать, как незначительные изменения глубины, времени или скорости всплытия могут изменить весь профиль погружения.
        <br><br>Для инструкторов это означает переход от простого объяснения концепций к демонстрации того, как они работают в режиме реального времени.
        <br><strong>Потому что цель не в том, чтобы студент запомнил правило. А в том, чтобы он осознал последствия своих решений еще до погружения в воду.</strong>`,



faq_txt: "FAQ",
login_txt: "Вход",

experiencia_interactiva: "Симулятор дайвинга | Тренировка на суше",

que_hace_2: "Divantys помогает вам понять дайвинг до погружения в воду, снижая риски. Yскоряя обучение и улучшая реальные решения под давлением.",



visualiza: "Освой теорию дайвинга. <strong>научись управлять и оптимизировать свои погружения</strong> до входа в воду",
que_hace_4: `
                <strong>Дайвинг — дорогое удовольствие, но обучение не обязано быть дорогим.</strong><br>
                Практикуйтесь в симуляторе, а не во время погружения, за которое вы платите.<br>
                Тренируйтесь на суше, набирайтесь опыта и используйте каждую минуту своего подводного приключения с максимальной пользой.`,


        all_levels: "Для начинающих дайверов и студентов вплоть до продвинутых дайверов и инструкторов", 
safety_gestion: "Управляй и выполняй остановки безопасности",
aire_profundidad: "Увеличивай время погружений, управляя глубиной",
gestion_deco: "Управляй и выполняй декомпрессионные остановки",
ppo2_gestion: "Управляй и визуализируй PPO2 в зависимости от глубины",


openModalBtn: "Посмотреть сводку",


ilustra: `
Симулятор учит тебя правильно действовать при ошибках,
  показывая тебе будущее твоих решений еще до того, как ты зайдешь в воду.
`,
preguntas_estrategicas_aprendizaje: `
Поэтому действительно важный вопрос заключается в следующем:<br>
  <ul>
    <li>Что произошло бы, если бы я принял другое решение?</li>
    <li>Что произойдет, если я останусь на дне еще на пять минут?</li>
    <li>Что произойдет, если я буду подниматься слишком быстро?</li>
    <li>Как изменятся мои ткани, если я использую другую газовую смесь?</li>
    <li>Как более глубокая или длительная остановка повлияет на мой декомпрессионный профиль?</li>
  </ul>
Симуляция позволяет ответить на эти вопросы немедленно, наглядно и безопасно.`,

relacion_pp: "Предупреждение ошибки — лучший прогресс для дайвера",
ndl: "Пределы без декомпрессии (NDL)",
absorcion: "Поглощение азота (ткани)",
exposicion: "Воздействие кислорода (PPO₂ / ЦНС)",
habitos_asenso: "Более безопасные привычки подъёма",
consumo_aire: "Расход воздуха и резерв",
buceo_recreativo: "Рекреационный дайвинг",
nitrox_compatible: "Совместим с Nitrox",
hud: "HUD на экране",
mobil_desktop: "Мобильные устройства + ПК",
startCta: "Открыть симулятор",
que_incluye: "Посмотреть, что включено",
tiempo: "Совет: вы можете ускорить время, чтобы быстрее наблюдать изменение показателей (например 2×, 5× или 10×).",
que_hace_3: "Что делает этот симулятор",
inmersion_virtual: "Divantys Dive Simulator — это интерактивная платформа для моделирования и обучения дайвингу, которая позволяет в реальном времени визуализировать физические и физиологические процессы, происходящие во время погружения. Ее цель — превратить сложные концепции теории дайвинга, декомпрессии и человеческой физиологии в понятный визуальный опыт для дайверов, студентов, инструкторов и профессионалов отрасли. Divantys работает как виртуальная лаборатория, где можно изучать, как человеческое тело реагирует на различные профили погружений, газовые смеси, глубины и время воздействия.",
experiencia_3d: "Управляемый 3D-опыт",
movimiento_cacara: "Движение и камера с управлением, адаптированным для мобильных устройств, планшетов и ПК.",
joistick_movimiento: "Джойстик движения",
joistick_rotacion: "Джойстик обзора/вращения",
neutral_flotabilidad: "Нейтральная зона для стабильности",
indicadores_hud: "Индикаторы HUD",
instrumentos_visuales: "Визуальные приборы на экране для мгновенного понимания.",
tanque: "Баллон: бар / PSI / процент",
barra_nitrogeno: "Шкала азота (обучающая)",
ndl_estado: "NDL и статус подъёма",
reporte: "Полный отчёт",
resumen: "Сводка погружения для обучения и анализа.",
profundidad_maxima: "Максимальная глубина",
tiempo_total: "Общее время",
ndl_total: "Общий и оставшийся NDL",
ceiling: "Ceiling (минимально безопасная глубина)",
modelos_txt: "Модели и представленные концепции",
simulador_implementa: "Симулятор реализует физиологические модели и образовательные правила, применяемые в рекреационном дайвинге: поглощение и выделение азота тканями, пределы без декомпрессии и воздействие кислорода.",
modelo_tejidos: "Модель тканей (16 компартментов)",
simulador_carge_nitrogeno: "Моделирует насыщение азотом в различных тканях с разной скоростью, позволяя оценить насыщение, «ceiling» и поведение при повторных погружениях.",
expoosicion_o2: "Воздействие кислорода (PPO₂ / ЦНС)",
calculo_po2: "Рассчитывает PPO₂ в зависимости от глубины и доли кислорода (FO₂), а также накапливает воздействие ЦНС с использованием модели пределов по PPO₂. Включает уровни предупреждений (OK / WARNING / DANGER).",
ndl2: "NDL (No Decompression Limit)",
caluclo_ndl: "Рассчитывает «рекреационный» NDL на основе глубины и времени, с поддержкой Nitrox (EAD).",
ndl_total_permitido: "Общий допустимый NDL",
ndl_restante: "Оставшийся NDL в зависимости от профиля",
interpretacion_riesgos: "Образовательная интерпретация риска",
ceiling_asecenso: "Ceiling и подъём",
estimacion_profundidad_ceiling: "Оценивает минимально безопасную глубину (ceiling) и определяет, можно ли выполнить подъём без остановок.",
ceiling_metros: "Ceiling в метрах",
deteccion_parada: "Обнаружение «требуется остановка»",
recomendacion_parada: "Рекомендация остановки безопасности",
inmersiones_repetitivas: "Повторные погружения",
carga_residual: "Сохраняет остаточную нагрузку между погружениями и моделирует поверхностные интервалы.",
tejidos_conservan: "Ткани сохраняют насыщение между погружениями",
intervalo_superficie: "Поверхностный интервал снижает нагрузку",
aprendizaje_acumulacion: "Изучение остаточного накопления",
instrumentos_visualizacion_hud: "Инструменты и визуализация (HUD)",
facilitar_comprension: "Для облегчения понимания симулятор отображает визуальные приборы на экране во время погружения. Его цель — чтобы пользователь «видел», как меняются концепции в зависимости от его поведения.",
tanque_aire: "Воздушный баллон (AL80)",
simula_consumo_sac: "Моделирует расход в зависимости от SAC, окружающего давления и симулированного времени.",
presion_bar_psi: "Давление в барах и PSI",
gas_restante: "Оставшийся процент",
alerta_reserva: "Предупреждение о резерве (например, 35 бар)",
sin_aire: "Состояние «без воздуха» (out of air)",
barra_nitrogeno_2: "Шкала азота",
visualizacion_educativa: "Обучающая визуализация увеличения/уменьшения нагрузки.",
suavisado_visual: "Визуальное сглаживание (медленная загрузка / нормальная разгрузка)",
colores_nivel: "Цвета по уровню (зелёный→красный)",
enfoque_didactico: "Дидактический подход, легко интерпретировать",
ndk_y_estado_ascenso: "NDL и статус подъёма",
indicadores_limites_descompresion: "Индикаторы для понимания пределов без декомпрессии и привычек подъёма.",
ndl_restante_2: "Оставшийся NDL",
recomendacion_parada_2: "Рекомендация остановки безопасности",
ceiling_si_aplica: "Ceiling (если применимо)",
escala_tiempo_safety_stop: "Шкала времени (1×, 2×, 5×, 10×)",
acelerar_tiempo: "Вы можете ускорить симуляцию, чтобы быстрее наблюдать изменения значений. Эта функция полезна для обучения: она показывает тенденции показателей без необходимости долгого ожидания.",
safety_stop_title: "Safety Stop (рекреационная остановка безопасности)",
safety_stop_resumen: "Этот модуль моделирует остановку безопасности на глубине 5 метров в рекреационном дайвинге. Его логика основана на масштабированном управлении в реальном времени, допуске по глубине и обнаружении прерываний или повторных погружений для подтверждения или отмены остановки.",
deteccion_recomendacion: "Рекомендация остановки",
safety_recommendation_meta: "Остановка рекомендуется автоматически на основе профиля погружения.",
profundidad_maxima_safety_stop: "Активируется, если максимальная глубина превышает 10 м",
exclusion_descompresion: "Деактивируется при наличии активной или требуемой декомпрессии",
estado_recomendado: "Статус: recommended → активирует остановку безопасности",
callback_recomendacion: "Необязательный callback уведомления пользователя",
logica_ejecucion: "Логика выполнения",
safety_execution_meta: "Система контролирует время в зоне 5 метров с учётом допуска и масштабирования времени.",
zona_parada: "Зона остановки: 5 м ± 2 м",
zona_pausa: "Зона паузы: 5 м - 3 м (без прогресса)",
acumulacion_tiempo_safety_stop: "Накопление времени в симулированных секундах",
escala_tiempo: "Масштабирование скоростью симуляции (GET_TIME_SCALE)",
completado_3min: "Завершено после 180 эффективных секунд",
pausa_reanuda: "Автоматическая пауза при выходе из зоны",
interrupciones_redescenso: "Прерывания и повторное погружение",
safety_interrupt_meta: "Обнаруживает, покидает ли дайвер остановку или возвращается на глубину после её завершения.",
rompe_parada: "Выход из зоны аннулирует прогресс",
cancelacion: "Состояние «cancelled» запускает сброс отслеживания",
interrupted_flag: "Отмечает прерывание при нарушении логики",
redescenso_invalida: "Повторное погружение > 6 м возобновляет рекомендацию",
ventana_tiempo: "Окно 30 с для аннулирования после завершения",
safety_stop_tiempo: "Контроль времени остановки",
safety_stop_explicacion: "Время рассчитывается в симулированном реальном времени и накапливается только тогда, когда дайвер находится в допустимом диапазоне. При выходе из зоны счётчик приостанавливается. После 3 эффективных минут остановка считается завершённой. Однако последующее повторное погружение может её аннулировать при определённых физиологических условиях.",
nitrogen_load_title: "Шкала нагрузки азота (обучающий интерфейс)",
nitrogen_load_resumen: "Этот модуль в реальном времени отображает нагрузку азота в быстрых тканях дайвера. Его цель — обучение: показать, как изменяется относительное насыщение во время погружения с помощью сглаженной и цветовой шкалы прогресса.",
visualizacion_n2: "Визуализация нагрузки N₂",
n2_visual_meta: "Упрощённо отображает уровень насыщения азотом в быстрых тканях.",


  ppo2_vizualiza:"PPO₂ и CNS",
    ppo2_visualiza_desc:"Визуализация кислородной токсичности с использованием PPO₂ и накопленного воздействия CNS. Состояние отображается через уровни физиологического риска.",
    ppo2_visualiza_p1:"Цветовая индикация уровня токсичности",
    ppo2_visualiza_p2:"Накопленный CNS",

    profundimetro:"Глубина в реальном времени",
    profundimetro_educativa:"Непрерывный мониторинг глубины для лучшего понимания изменения профиля погружения.",
    profundimetro_visualiza_p1:"Динамическое обновление глубины на протяжении всего погружения.",
    profundimetro_visualiza_p2:"Визуальное сглаживание, имитирующее работу реальных приборов.",






    tejidos_rapidos: "Основано на быстрых тканях физиологической модели",
valor_porcentual: "Значение выражено в процентах (0–130%)",
suavizado_visual_2: "Визуальное сглаживание для предотвращения резких скачков",
actualizacion_tiempo_real: "Обновление в реальном времени",
codigo_colores_n2: "Цветовая кодировка",
n2_colors_meta: "Полоса меняет цвет в зависимости от уровня нагрузки для упрощения быстрой интерпретации.",
verde_seguro: "Зелёный: низкая и стабильная нагрузка (< 60%)",
amarillo_atencion: "Жёлтый: зона внимания (60%–85%)",
naranja_alto: "Оранжевый: высокая нагрузка (85%–100%)",
rojo_riesgo: "Красный: потенциальная пересатурация (> 100%)",
logica_suavizado: "Логика сглаживания и стабильности",
n2_smoothing_meta: "Визуальное значение не меняется мгновенно, а постепенно приближается к реальному значению.",
interpolacion_visual: "Постепенная интерполяция (ease-in / ease-out)",
respuesta_diferencial: "Более медленная реакция на увеличение, чем на уменьшение",
prevencion_flicker: "Предотвращение визуального мерцания",
clamp_visual: "Ограничение значений в диапазоне 0%–130%",
n2_bar_texto_secundario: "Вторичная информация (GF / физиологическое состояние)",
n2_bar_explicacion: "Полоса может включать дополнительный текст (например, Gradient Factor или состояние физиологической модели). Это позволяет визуально соотнести насыщение азотом со статусом декомпрессии, предлагая более интуитивное представление накопленного риска.",
air_consumption_title: "Потребление воздуха (AL80, многобаллонная система)",
air_consumption_resumen: "Этот модуль моделирует реальное потребление газа в динамическом времени с использованием SAC (Surface Air Consumption), давления окружающей среды и масштабирования времени. Поддерживает конфигурации с одним или несколькими баллонами и рассчитывает постепенное истощение всей системы.",
modelo_consumo: "Модель потребления",
air_model_meta: "Потребление основано на SAC дайвера с учётом давления окружающей среды и смоделированного времени.",
sac_rate: "Настраиваемый пользователем SAC",
presion_ambiente: "Давление окружающей среды = 1 + глубина/10",
escala_tiempo_aire: "Масштабирование через GET_TIME_SCALE()",
consumo_proporcional: "Пропорциональное потребление на баллон",
sistema_multitanque: "Многобаллонная система",
air_tanks_meta: "Система распределяет потребление между всеми активными баллонами в конфигурации.",
al80_base: "Базовый баллон AL80 (2265 л)",
multi_tank_support: "Поддержка нескольких баллонов",
division_consumo: "Потребление распределяется между активными баллонами",
estado_out_of_air: "Глобальное состояние OUT OF AIR",
visualizacion_hud_aire: "Отображение HUD",
air_hud_meta: "Каждый баллон представлен вертикальной шкалой уровня и показанием давления в барах и PSI.",
nivel_visual_barra: "Визуальный уровень по проценту объёма",
bar_psi_conversion: "Конверсия бар / PSI в реальном времени",
colores_reserva: "Цвет в зависимости от резерва (зелёный → оранжевый → красный)",
alerta_reserva_aire: "Предупреждение ниже 35 бар",
air_system_tank_title: "Состояние системы воздуха",
air_system_explainer: "Система рассчитывает общий оставшийся объём, суммируя все активные баллоны. Потребление обновляется на каждом симулированном кадре и позволяет определить момент резерва или критическое состояние «без воздуха». Модель отражает как индивидуальное, так и общее потребление.",
oxygen_toxicity_title: "Кислородная токсичность (NOAA CNS)",
oxygen_toxicity_resumen: "Этот модуль оценивает риск кислородной токсичности с использованием PPO₂ и накопленного CNS. Состояние отображается через уровни физиологического риска, аналогичные дайв-компьютеру.",
ppo2_model: "Парциальное давление кислорода (PPO₂)",
ppo2_meta: "Определяет непосредственный риск острой токсичности.",
formula_ppo2: "PPO₂ = FO₂ × давление окружающей среды",
limite_ppo2: "Рабочий предел: 1.4 бар",
limite_critico: "Критический: ≥ 1.6 бар",
cns_model: "CNS (Центральная нервная система)",
cns_meta: "Постепенное накопление воздействия кислорода согласно модели NOAA.",
noaa_model: "Модель воздействия NOAA",
acumulacion_cns: "Постепенное увеличение со временем",
limite_cns: "100% = рекомендуемый предел",
estado_oxigeno: "Состояние кислородной токсичности",
oxy_state_meta: "Комбинированная оценка PPO₂ и CNS в реальном времени.",
stateOK: "OK",
stateWARN: "ПРЕДУПРЕЖДЕНИЕ",
stateDANGER: "ОПАСНО",
state_ok: "OK: воздействие в безопасных пределах",
state_warning: "ПРЕДУПРЕЖДЕНИЕ: зона осторожности",
state_danger: "ОПАСНО: риск острой токсичности",
oxygen_system_title: "Модель риска кислорода",
oxygen_system_explainer: "Система объединяет острую токсичность (PPO₂) и накопительную токсичность (CNS). Отображаемое состояние отражает доминирующий уровень риска в каждый момент погружения, аналогично реальному техническому дайв-компьютеру.",
logica_deco_engine: "Логика декомпрессионного двигателя (Bühlmann + GF)",
resumen_logica_deco: "Этот модуль в реальном времени рассчитывает декомпрессионный план дайвера, моделируя насыщение тканей азотом, генерируя обязательные остановки и корректируя профиль всплытия в зависимости от физиологического состояния и градиента безопасности (GF). Также ведётся постоянная история для сохранения прогресса между перерасчётами плана.",
generacion_plan: "Генерация декомпрессионного плана",
plan_buhlmann: "Система строит профиль остановок на основе модели Бюльмана с Gradient Factors.",
calculo_ceiling: "Расчёт потолка (ceiling) по линии GF (безопасный предел всплытия)",
redondeo_paradas: "Округление до ступеней остановок (STOP_STEP_M)",
simulacion_exposicion: "Моделирование нагрузки тканей на каждой остановке",
condicion_fin: "Завершается, когда потолок опускается ниже 3 м (STOP_REQUIRED_M)",
modo_preview: "Режим предпросмотра без влияния на реальную историю",
historial_persistencia: "История и сохранение остановок",
deco_history: "Система сохраняет прогресс каждой остановки, чтобы избежать потери состояния при перерасчётах.",
decohistory_array: "decoHistory хранит прогресс по глубине",
hydrate_paradas: "Восстановление остановок из истории",
preserva_progreso: "Сохраняет выполненное время (timePerformedSec)",
evita_reset: "Предотвращает сброс уже начатых остановок",
merge_plan: "Объединение нового плана с предыдущим состоянием",
update_deco_logic: "Движок непрерывно пересчитывает состояние декомпрессии в зависимости от глубины, смоделированного времени и тканей.",
control_parada_actual: "Контроль текущей остановки с допуском по глубине",
bloqueo_orden: "Блокировка порядка (нельзя пропускать предыдущие остановки)",
regeneracion_dinamica: "Перегенерация при ухудшении или улучшении профиля",
acumulacion_tiempo: "Накопление времени по dtSimSec",
auto_complete: "Автозавершение при 95% выполнения",
tts_dinamico: "Динамический расчёт TTS (всплытие + остановки)",
tts_resumen: "Общее время до поверхности (TTS)",
tts_explicacion: "TTS рассчитывается путём объединения времени всплытия по сегментам (в зависимости от скорости всплытия) с оставшимся временем на активных декомпрессионных остановках. Результат постоянно корректируется в зависимости от реального состояния тканей и текущего плана.",
uso_responsable: "Ответственное использование и важное предупреждение",
herramienta_educativa: "Этот проект является образовательным и демонстрационным инструментом. Реальное дайвинг требует обучения, сертифицированного оборудования и профессионального контроля.",
importante: "Важно",
que_hace_3_txt: "Этот симулятор <strong>не является</strong> курсом дайвинга, <strong>не заменяет</strong> формальное обучение и <strong>не является</strong> дайв-компьютером или инструментом планирования. Его <strong>нельзя</strong> использовать для планирования реальных погружений или принятия решений. Всё показанное предназначено <strong>исключительно для иллюстрации</strong>, с использованием концепций и алгоритмов только для симуляции и визуализации. Использование симулятора осуществляется на ответственность пользователя.",
ackCheck: "",
entiendo_educativo: "Я понимаю, что этот симулятор предназначен только для образовательных целей, не заменяет сертифицированное обучение или дайв-компьютер и не должен использоваться для планирования или выполнения реальных погружений.",
enterBtn: "Войти в симулятор",
learnMoreBtn: "Посмотреть детали системы",
faq_txt_2: "Часто задаваемые вопросы",
que_es: "Это планировщик погружений?",
es_aprendizaje_visual: "Нет. Это инструмент визуального обучения. Его нельзя использовать для планирования реальных погружений.",
que_gases_contempla: "Какие газы учитываются?",
cuales_gases: "Учитываются воздух и нитрокс через долю кислорода (FO₂), влияя на NDL, азот и PPO₂/CNS.",
mobil_funciona: "Работает ли на мобильных устройствах?",
si_funciona_mobil: "Да. Управление адаптируется с помощью джойстиков и обработки событий указателя (pointer events).",
team_txt_2: "Команда",

se_descarga: "Нужно ли скачивать приложение?",
no_se_descarga: "Мы используем технологию <strong>3D WebGL</strong>, поэтому вам не нужно загружать приложение из магазина. Вы можете пользоваться сервисом бесплатно и без ограничений прямо в вашем браузере.",


gonzalo_desc: "Инструктор по дайвингу | Технический специалист по ПО",
title_footer: "Симулятор погружения",
footer_experiencia: "Образовательный и демонстрационный опыт",
consejo_ambiental: "Экологический совет: поддержание плавучести и осознанное движение защищают риф и морскую жизнь.",
modalTitle: "Сводка системы",
closeModalBtn: "Закрыть",
actualiza_indicadores: "Симулятор обновляет показатели безопасности и физиологии во время виртуального погружения и формирует итоговый отчёт для обучения.",
fisiologia: "Физиология (ткани)",
compartimentos_2: "16 смоделированных компартментов, насыщение азотом и оценка потолка/всплытия.",
ndl_nitros: "NDL и Nitrox",
ndl_recreativo: "Рекреационный NDL, поддержка FO₂ с эквивалентной глубиной (EAD) в образовательных целях.",
consumo_aire_2: "Потребление воздуха",
consumo_basado_sac: "Потребление основано на SAC, давлении окружающей среды и смоделированном времени; предупреждения о резерве и отсутствии воздуха.",
oxigeno_cns: "Кислород (PPO₂ / CNS)",
calculo_ppo2: "Рассчитывает PPO₂ на основе глубины и FO₂; накапливает CNS и отображает предупреждения.",
fines_educativos: "Примечание: все значения и визуализации предназначены только для образовательных и симуляционных целей.",
closeSlideBtn: "❌",

safety_stop_menu: "Пауза безопасности",
nitrogen_bar_menu: "Панель N₂",
consumo_aire_menu: "Расход газа",
oxicidad_oxigeno_menu: "Токсичность O₂",
deco_menu: "ДЕКО",
deco_y_paradas_deco: "ДЕКО и его декомпрессионные остановки",

registro_existoso: "Регистрация завершена!",
instrucciones_email_registro: "Ваша учетная запись была успешно создана. Пожалуйста, подтвердите свой аккаунт по электронной почте, чтобы войти! Спасибо",
cintinuar: "Продолжить",



},


payment_stripe:{

  title:"Безопасная оплата через Stripe",
  ammount_txt:"Итого к оплате:<br>",
  currency:"Евро",
  pagar_ahora:"Оплатить сейчас",
  continuar:"Продолжить",
  cancelar:"Отмена",
  error: "Ошибка",
  completa_inputs:"Пожалуйста, заполните все поля",
  close:"Закрыть",
  error_passwords:"Ошибка пароля",
  passwords_no_iguales:"Пароли не совпадают",
  error_email: "Ошибка email",
  ingresa_email_valido:"Пожалуйста, введите корректный email.",
  user_data:"Данные пользователя",
  create_account:"Создать новый аккаунт",
  pago_exitoso:"Оплата успешна",
  pago_compeltado:"Ваш платеж успешно завершён",
  pago_proceso:"Платеж обрабатывается",
  confirmaremos_pago:"Мы подтвердим ваш платеж в ближайшее время",
  pago_fallido:"Ошибка оплаты",
  fallo_autenticacion_declinado:"Ошибка аутентификации или платеж отклонён",
  status_pago:"Статус платежа",
  cuenta_existente:"Этот аккаунт уже существует",
  cuenta_existente_txt:"Этот email уже был зарегистрирован"

},




login:{

  iniciar_session: "Войти",
  accede_a_cuenta:"Войдите в свой аккаунт",
  email:"Email",
  password:"Пароль",
  iniciar_session_btn:"Войти сейчас",
  verificando:"Проверка.....",
  credenciales_incorrectas:"Неверные учетные данные"

},



stripe_user_data:{
  user_data:"Данные пользователя",
  create_account:"Создать новую учетную запись",
  username:"Имя пользователя",
  enter_username:"Введите полное имя",
  email_user:"Электронная почта пользователя",
  enter_email:"Введите email",
  password:"Пароль",
  enter_password:"Введите пароль",
  repeat_password:"Повторите пароль",
  enter_repeat_password:"Введите тот же пароль",
  seleccion_suscripcion:"Выберите тип подписки",
  mensual:"Ежемесячно",
  semestral:"Раз в полгода",
  anual:"Ежегодно"
},


cookies:{
  title:"Обязательные файлы cookie",
  message:"Этот сайт использует файлы cookie для корректной работы. Вы должны принять их использование, чтобы продолжить.",
  reject:"Отклонить",
  accept:"Принять",
  acceso_denegado:"Доступ запрещён",
  debes_aceptar:"Для продолжения требуется согласие на использование файлов cookie"
},


condiciones:{

  full:  ` 


<div id="legal_conditions" class="legal_conditions">

<div class="legal_header">
<h1>Условия использования</h1>
</div>


<div id="legal_scroll_container" class="legal_scroll_container">


<div class="section_legal">

<h2>1. ИДЕНТИФИКАЦИЯ ВЛАДЕЛЬЦА</h2>

<p>
В соответствии с Законом 34/2002 об услугах информационного общества (LSSI-CE)
сообщается, что данный веб-сайт принадлежит:
</p>

<ul>
<li><strong>DIVANTIS</strong></li>
<li><strong>Контактный email:</strong> admin@divantys.com</li>
<li><strong>Юридический адрес:</strong> Малага, Испания</li>
<li><strong>Деятельность:</strong> предоставление удалённых цифровых услуг</li>
</ul>

</div>


<div class="section_legal">

<h2>2. ЦЕЛЬ И УСЛОВИЯ ИСПОЛЬЗОВАНИЯ</h2>

<p>
Данный веб-сайт предоставляет цифровые услуги,
интерактивный контент и онлайн-инструменты.
Доступ к сайту означает принятие настоящих условий.
</p>

<p>Пользователь обязуется:</p>

<ul>
<li>Не осуществлять незаконную деятельность</li>
<li>Не внедрять вредоносный код</li>
<li>Не пытаться получить доступ к закрытым системам</li>
<li>Не использовать сайт в мошеннических целях</li>
</ul>

</div>


<div class="section_legal">

<h2>3. ИНТЕЛЛЕКТУАЛЬНАЯ СОБСТВЕННОСТЬ</h2>

<p>
Все материалы сайта (тексты, код, дизайн, программное обеспечение и изображения)
являются собственностью владельца или используются по лицензии.
Запрещается их воспроизведение, распространение или изменение
без явного разрешения.
</p>

</div>


<div class="section_legal">

<h2>4. ДОСТУПНОСТЬ СЕРВИСА</h2>

<p>
Владелец имеет право изменять, приостанавливать
или прекращать работу любого сервиса или функции сайта
в любое время без предварительного уведомления.
</p>

</div>


<div class="section_legal">

<h2>5. ОГРАНИЧЕНИЕ ОТВЕТСТВЕННОСТИ</h2>

<p>
Сайт предоставляется «как есть».
Владелец не гарантирует постоянную доступность
или отсутствие технических ошибок.
</p>

<p>
Владелец не несёт ответственности за ущерб,
возникший в результате использования
или невозможности использования предоставляемых услуг.
</p>

</div>


<div class="section_legal">

<h2>6. ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ (GDPR)</h2>

<h3>Собираемые данные</h3>

<ul>
<li>Имя</li>
<li>Адрес электронной почты</li>
<li>Данные, отправленные через формы</li>
<li>Технические данные навигации</li>
</ul>

<h3>Цель обработки</h3>

<ul>
<li>Ответ на запросы</li>
<li>Отправка запрошенной информации</li>
<li>Улучшение сервиса</li>
<li>Коммерческие сообщения (с согласия пользователя)</li>
</ul>

</div>


<div class="section_legal">

<h2>7. ХРАНЕНИЕ ДАННЫХ</h2>

<p>
Персональные данные хранятся только в течение времени,
необходимого для выполнения целей, указанных в данной политике,
или для соблюдения юридических обязательств.
</p>

</div>


<div class="section_legal">

<h2>8. СЕРВИСЫ ТРЕТЬИХ СТОРОН</h2>

<p>
Сайт может использовать сервисы третьих сторон,
такие как платёжные системы, хостинг-провайдеры
или аналитические инструменты.
</p>

<p>
Эти поставщики могут обрабатывать некоторые
технические или персональные данные
в соответствии со своими собственными политиками конфиденциальности.
</p>

</div>


<div class="section_legal">

<h2>9. МЕЖДУНАРОДНАЯ ПЕРЕДАЧА ДАННЫХ</h2>

<p>
Если используются технологические поставщики,
находящиеся за пределами Европейской экономической зоны,
применяются стандартные договорные положения,
утверждённые Европейской комиссией.
</p>

</div>


<div class="section_legal">

<h2>10. ПОЛИТИКА COOKIE</h2>

<p>
Сайт может использовать технические и аналитические cookie-файлы
для улучшения пользовательского опыта
и функциональности сайта.
</p>

</div>


<div class="section_legal">

<h2>11. ИЗМЕНЕНИЯ</h2>

<p>
Владелец может в любое время изменить данные условия.
Изменения вступают в силу с момента публикации на сайте.
</p>

</div>


<div class="section_legal">

<h2>12. ПРИМЕНИМОЕ ПРАВО И ЮРИСДИКЦИЯ</h2>

<p>
Настоящие условия регулируются законодательством Испании.
Стороны подчиняются судам города Малага, Испания.
</p>

</div>


<div class="section_legal">

<h2>13. КОНТАКТ</h2>

<p>
По всем вопросам, связанным с данной политикой:
</p>

<p>
📧 admin@divantys.com
</p>

</div>


</div>



<div class="legal_controls">

<button id="legal_continue_btn">
Принять и продолжить
</button>

</div>

</div>

    ` 

},


 // ===================================================
  // GENERAL
  // ===================================================
  general: {
    ok: "OK",
    cancel: "Отмена",
    salir: "Выход",
    button_fisiologia: "Физиология дайвинга",
    closeReset: "Закрыть и сбросить",
    startDive: "Начать погружение",
    startNextDive: "Начать следующее погружение",
    firstDive: "Первое погружение",
    repetitiveDive: "Повторное погружение",
    Dive: "Погружение №",
    reduce_ascent_speed: "Снижение скорости всплытия уменьшает азотную нагрузку.",
    controlled_ascent_text:
      "Помните, что всплытия должны быть медленными и контролируемыми, чтобы избежать насыщения тканей. Используйте «Азотную нагрузку» как ориентир."
  },

  // ===================================================
  // ALERTS / MESSAGES
  // ===================================================
  alerts: {
    notice: "Уведомление",
    invalidSurface: "Недопустимый поверхностный интервал",
    noRepetitive: "После этого погружения повторные погружения не допускаются",
    noTissueData: "Данные по тканям отсутствуют",
    recalculating: "Пересчёт тканевых компартментов…",

    outOfAir: {
      title: "🚨 Нет воздуха",
      button: "Понятно",
      html: `
        <strong>Обнаружена критическая ситуация.</strong><br><br>

        • Запас дыхательного газа исчерпан<br>
        • Немедленно начните контролируемое всплытие<br>
        • Непрерывный выдох (CESA)<br>
        • Соблюдайте безопасную скорость всплытия<br><br>

        <em>Погружение завершено по соображениям безопасности.</em>
      `
    },

    modExceeded: {
      icon: "🫁⚠️",
      color: "#c62828",
      title: "🚨 Превышена MOD для EAN{{ean}}",
      button: "Понятно",
      html: `
        <strong>Вы находитесь глубже безопасной рабочей глубины для данного газа.</strong><br><br>

        <strong>Детали:</strong><br>
        • Текущая глубина: <strong>{{depth}} м</strong><br>
        • MOD (PPO₂ 1,4): <strong>{{mod}} м</strong><br>
        • Действие: <strong>немедленно всплывайте</strong> на меньшую глубину<br><br>

        <em>Погружение завершено по соображениям безопасности.</em>
      `
    },

    recreationalLimitExceeded: {
      icon: "🚫",
      color: "#c62828",
      title: "🚨 Превышены рекреационные пределы",
      button: "Понятно",
      html: `
        <strong>Вы превысили стандартные пределы рекреационного дайвинга.</strong><br><br>

        <strong>Это означает:</strong><br>
        • Рекреационная бездекомпрессионная граница больше не применяется<br>
        • Может потребоваться декомпрессия<br>
        • Требуется техническая подготовка<br>
        • Может потребоваться планирование газа и поэтапные всплытия<br><br>

        <em>Погружение завершено по соображениям безопасности.</em>
      `
    },

    ndlExceeded: {
      icon: "⏱",
      color: "#c62828",
      title: "🚨 Превышен бездекомпрессионный предел",
      button: "Понятно",
      html: `
        <strong>Вы превысили бездекомпрессионный предел.</strong><br><br>

        <strong>Требуемые действия:</strong><br>
        • Немедленно начните медленное и контролируемое всплытие<br>
        • Максимальная скорость всплытия: <strong>9–10 м/мин</strong><br>
        • Выполните остановку безопасности на <strong>5 м в течение 3–5 минут</strong><br><br>

        <em>Погружение завершено по соображениям безопасности.</em>
      `
    },

    safetyStopInterrupted: {
      title: "Остановка безопасности прервана",
      text: "Опуститесь на 5 метров, чтобы возобновить остановку безопасности.",
      color: "warning"
    },

    safetyStopCompleted: {
      title: "Остановка безопасности выполнена",
      text: "Вы можете безопасно продолжить всплытие.",
      color: "success"
    },

    low_air_reserve_reached: {
      title: "Низкий запас воздуха — достигнут резерв",
      text: `
Достигнут резерв воздуха (≈35 бар).

• Начните медленное и контролируемое всплытие
• Не превышайте 9–10 м/мин
• Подготовьтесь к остановке безопасности на 5 м
• Сохраняйте спокойствие и дышите медленно`,
      color: "warning"
    }
  },

  // ===================================================
  // LOGS / STATES
  // ===================================================
  logs: {
    decoRequired: "🚨 Требовалась декомпрессия (рекреационный критерий)",
    nearNDL: "⚠️ Близко к бездекомпрессионному пределу",
    highTissue: "🟠 Высокая тканевая нагрузка (физиологическая модель)",
    withinLimits: "✅ Погружение в пределах рекреационных норм"
  },

  // ===================================================
  // DIVE STATUS
  // ===================================================
  diveStatus: {
    completed: "✅ Погружение завершено",
    failedDeco: "🚨 Погружение неудачно — требовалась декомпрессия",
    highTissue: "⚠️ Погружение завершено — высокая тканевая нагрузка",
    nearNDL: "⚠️ Погружение завершено — близко к бездекомпрессионному пределу",
    dangerous_ascent: "🚨 В какой-то момент у вас был неконтролируемый подъём. Будьте осторожны",
    fast_ascent: "⚠️ В какой-то момент вы поднимались быстрее максимально допустимой скорости (9 м/мин). Всегда контролируйте подъём и заранее учитывайте изменения глубины"
  },

  // ===================================================
  // SAFETY STOP
  // ===================================================
  safetyStop: {
    title: "Остановка безопасности",
    completed: "✅ <strong>Остановка безопасности выполнена</strong>",
    notCompleted: "⚠️ <strong>Остановка безопасности не выполнена</strong>",
    timeAt5m: "Время на 5 м",
    completedAfterInterruptions: "Выполнена с прерываниями",
    back_5m: "⬆️ Вернуться на 5 м",
    hold_5m: "⏸ Оставаться на 5 м",
    target_depth: "Целевая глубина: 5 м"
  },

  nitrogen_bar: {
    title: "Нагрузка N₂ (быстрые ткани)"
  },

  // ===================================================
  // REPORT / SUMMARY
  // ===================================================
  report: {
    diveNumber: "Погружение",
    time: "Время",
    maxDepth: "Макс. глубина",
    gas: "Газ",
    tank: "Баллон",
    startPressure: "Начальное давление",
    endPressure: "Конечное давление",
    airUsed: "Израсходованный воздух",
    sac: "SAC",
    reserveReached: "Резерв достигнут",
    ceiling: "Потолок",
    gf: "GF",
    tissueTitle: "Тканевые компартменты",
    tissueNote:
      "Красные компартменты указывают на лимитирующие ткани — обязательная декомпрессия не требуется.",
    ceiling: "Потолок",
    safetystop: "Остановка безопасности"
  },

  camera_hud: {
    t1: "Настроить нейтральный трим",
    level_ok: "✓ Нейтрально",
    level_hint: "Нажмите ⦿ для нейтрального трима"
  },

  // ===================================================
  // PROFILE
  // ===================================================
  profile: {
    title: "Профиль глубины"
  },

  // ===================================================
  // TISSUES
  // ===================================================
  tissues: {
    title: "Тканевые компартменты (N₂)",
    surfaceOffGassing: "Выведение газа на поверхности",
    afterInterval: "После",
    minutes: "мин",
    offGas: "⬇ десатурация",
    onGas: "⬆ насыщение",
    tissues_data_invalidos: "Информация о тканях отсутствует"
  },

  // ===================================================
  // SURFACE INTERVAL
  // ===================================================
  surface: {
    title: "Поверхностный интервал (мин)",
    invalid_interval_surface: "Недопустимая продолжительность поверхностного интервала",
    recalc: "Пересчитать ткани",
    after: "После",
    notAllowed: "После этого погружения повторные погружения не допускаются"
  },

  // ===================================================
  // REPETITIVE DIVES
  // ===================================================
  repetitive: {
    tag: "Повторное погружение",
    info:
      "Это погружение начинается с остаточного азота от предыдущего погружения. Рекомендуется консервативное всплытие и полная остановка безопасности.",
    first_dive: "Первое погружение",
    repetitive_dive: "Повторное погружение"
  },

  // ===================================================
  // EDUCATION / LEGAL NOTICE
  // ===================================================
  education: {
    longHTML: `
<strong>ℹ️ Почему появилось это сообщение?</strong><br><br>

<strong>Во время данной симуляции профиль оставался в пределах отображаемых бездекомпрессионных лимитов.</strong>
Ни в один момент динамический бездекомпрессионный предел (NDL),
отображаемый системой, не достиг нуля,
и обязательные декомпрессионные остановки в рамках симуляции не формировались.
<br><br>

Отображаемое сообщение <strong>не указывает на ошибку, неудачное погружение или нарушение</strong>.
Оно носит исключительно информационный характер и основано
на <strong>той же внутренней физиологической модели</strong>,
которая последовательно применялась на протяжении всей симуляции.
<br><br>

<strong>Как работает этот симулятор?</strong><br>
Данный симулятор является <strong>инструментом визуализации и иллюстрации</strong>,
предназначенным для демонстрации общих принципов физиологии дайвинга.
Он основан на <strong>теоретической модели непрерывного отслеживания тканей</strong>,
вдохновлённой широко документированными декомпрессионными моделями
(такими как Bühlmann ZHL-16C с логикой градиент-факторов),
и используется исключительно в демонстрационных целях.
<br><br>

Во время симулированного погружения система:
<ul style="margin:8px 0 0 18px;">
  <li>отображает относительные оценки поглощения инертного газа теоретическими тканевыми компартментами</li>
  <li>показывает приближение этих компартментов к смоделированным пределам</li>
  <li>иллюстрирует изменение консервативности всплытия <em>только в рамках симуляции</em></li>
</ul>
<br>

<strong>Почему может появиться уведомление, если NDL был соблюдён?</strong><br>
Даже при отсутствии отображаемых декомпрессионных обязательств
модель может показывать <strong>относительно высокую нагрузку инертного газа</strong>
в некоторых симулированных тканях.
Это может происходить при профилях, включающих:
<ul style="margin:8px 0 0 18px;">
  <li>длительное пребывание на дне</li>
  <li>погружения, близкие к бездекомпрессионному пределу</li>
  <li>умеренные глубины, поддерживаемые в течение длительного времени</li>
</ul>
<br>

В таких случаях система может отображать
<strong>профилактическое информационное сообщение</strong>,
единственной целью которого является предоставление дополнительного физиологического контекста в рамках визуализации.
Это сообщение <strong>не является эксплуатационной инструкцией или рекомендацией по погружению</strong>.
<br><br>

<strong>🟠 Важное разъяснение:</strong><br>
Данное сообщение <strong>не представляет собой требования к декомпрессии</strong>,
<strong>не является тревогой или указанием дайв-компьютера</strong>
и <strong>не подразумевает небезопасные, неправильные или несоответствующие практики</strong>.
Оно лишь отражает то, что в рамках симулированной модели
некоторые ткани имели относительно более высокую нагрузку инертного газа
по сравнению с типичным коротким рекреационным погружением.
<br><br>

<strong>Проще говоря:</strong><br>
Симулированный профиль оставался в пределах отображаемых лимитов.
Это сообщение лишь означает:
<em>«Данный симулированный сценарий приблизился к консервативной границе, поэтому отображается дополнительная контекстная информация.»</em>
<br><br>

<strong>Юридическое уведомление:</strong><br>
Этот симулятор предоставляется <strong>исключительно в целях визуализации и иллюстрации</strong>.
<strong>Он не является дайв-компьютером</strong>,
<strong>не заменяет сертифицированное обучение и образовательную роль признанных дайв-агентств</strong>,
и <strong>не должен использоваться в качестве основы для принятия решений при реальных погружениях</strong>.
`
  },

  // ===================================================
  // PRE-DIVE CHECK
  // ===================================================
  predive: {
    title: "Проверка безопасности перед погружением",
    subtitle: "Стандартная проверка безопасности перед погружением (BWRAF) и выбор газа",
    selectGas: "Выберите дыхательный газ",
    start: "Начать погружение",
    cancel: "Отмена и сброс",
    descargar: "Скачать отчёт",
    bwraf: {
      b: "BCD: надув / сдув, инфлятор исправен",
      w: "Грузы: правильный вес, быстрый сброс свободен",
      r: "Крепления: ремни, пряжки и баллон закреплены",
      a: "Воздух: вентиль открыт, дыхание и проверка давления",
      f: "Финал: маска, ласты, компьютер, напарник готов"
    }
  },


  scale_time_home: {
  title: "Масштаб времени симуляции",
  text: `
    Этот симулятор может <strong>ускорять время</strong>, чтобы наглядно
    показать физиологические процессы (NDL, насыщение азотом,
    поведение при подъёме), которые в реальном дайвинге занимают гораздо больше времени.
    <br><br>
    Это <strong>не</strong> является реальным временем и используется
    <strong>исключительно в учебных и визуальных целях</strong>.
  `,
  real_time: "Реальное время",
  choose: "Выберите скорость симуляции:",
  start: "Начать погружение"
},



comparativa_tablas_tejidos_bhulmann: {
  text: `
    <div style="display:flex; flex-direction:column; gap:14px; line-height:1.65; color:#eaf4ff;">

      <div style="background:rgba(255,255,255,.06); border:1px solid rgba(255,255,255,.08); border-radius:16px; padding:16px;">
        <div style="font-size:18px; font-weight:700; margin-bottom:8px;">
          🧠📊 Таблицы vs Физиологическая модель
        </div>
        <div style="font-size:14px; opacity:.95;">
          Оба подхода используются для оценки предела бездекомпрессионного погружения (NDL), но <strong>они работают по-разному</strong>.
          Поэтому результаты могут отличаться.
        </div>
      </div>

      <div style="display:grid; gap:12px;">
        
        <div style="background:rgba(0,153,255,.10); border:1px solid rgba(0,153,255,.25); border-radius:16px; padding:16px;">
          <div style="font-size:16px; font-weight:700; margin-bottom:8px;">
            🔵 Рекреационные таблицы (PADI / DSAT)
          </div>
          <div style="font-size:14px;">
            <div>⏱️ Дают <strong>фиксированное время</strong> в зависимости от глубины.</div>
            <div>📚 Основаны на исследованиях и запасах безопасности.</div>
            <div>🧮 <strong>Не рассчитывают</strong> состояние организма в реальном времени.</div>
            <div>🟢 Простые, быстрые и удобные в использовании.</div>
          </div>

          <div style="margin-top:10px; font-size:14px; background:rgba(255,255,255,.05); border-radius:12px; padding:10px;">
            👉 Пример: на глубине <strong>20 м</strong> таблица может показывать <strong>NDL ≈ 45 мин</strong>.
          </div>
        </div>

        <div style="background:rgba(0,255,170,.08); border:1px solid rgba(0,255,170,.22); border-radius:16px; padding:16px;">
          <div style="font-size:16px; font-weight:700; margin-bottom:8px;">
            🟢 Модель Бюльмана (этот симулятор)
          </div>
          <div style="font-size:14px;">
            <div>🧠 Моделирует <strong>16 виртуальных тканей</strong> организма.</div>
            <div>📈 В реальном времени рассчитывает поглощение и выведение азота.</div>
            <div>⚙️ Учитывает ваш реальный профиль погружения: <strong>глубину, время и газ</strong>.</div>
            <div>🎯 Более динамичный и реалистичный подход.</div>
          </div>

          <div style="margin-top:10px; font-size:14px; background:rgba(255,255,255,.05); border-radius:12px; padding:10px;">
            👉 Здесь <strong>NDL не фиксирован</strong>: это момент, когда становится необходимой <strong>декомпрессионная остановка</strong>.
          </div>
        </div>

      </div>

      <div style="background:rgba(255,196,0,.10); border:1px solid rgba(255,196,0,.25); border-radius:16px; padding:16px;">
        <div style="font-size:16px; font-weight:700; margin-bottom:8px;">
          ⚠️ Почему результаты отличаются?
        </div>
        <div style="font-size:14px;">
          <div>📚 Рекреационные таблицы более <strong>консервативны</strong>.</div>
          <div>🧠 Модель Бюльмана непрерывно рассчитывает реальные процессы в организме.</div>
          <div>🔍 Поэтому симулятор может показывать другой NDL по сравнению с классическими таблицами.</div>
        </div>
      </div>

      <div style="background:rgba(255,255,255,.06); border:1px solid rgba(255,255,255,.08); border-radius:16px; padding:16px;">
        <div style="font-size:16px; font-weight:700; margin-bottom:8px;">
          💡 Итог
        </div>
        <div style="font-size:14px;">
          <div>🔵 <strong>Таблицы</strong> = простая и консервативная оценка</div>
          <div>🟢 <strong>Бюльман</strong> = более реалистичная физиологическая модель</div>
        </div>

        <div style="margin-top:10px; font-size:14px; font-weight:600;">
          👉 Этот симулятор использует модель Бюльмана для более динамичного расчёта NDL.
        </div>
      </div>

    </div>
  `
},


block_student: {
    riesgo_accidente_disbarico: "Высокий риск декомпрессионной болезни",
    riesgo_microburbujas: "Риск образования микропузырьков",
    reducir_velocidad: "Необходимо снизить скорость всплытия до 9 м/мин",
    ascenso_ideal: "Идеальная скорость всплытия",
    ascenso_lento: "Медленное всплытие. Правильно",
    ascent_rate: "Скорость всплытия"
},



dashboard:{
  profile_txt: "Мой профиль",
    logout_txt:"Выйти",
    welcome_label:"Добро пожаловать",
    payments_title:"Панель платежей",
    startSimulatorBtn:"🎮 Запустить симулятор погружения",
    view_payments:"Посмотреть платежи",
    view_simulator_logs:"Логи симулятора",
    paymentsEmpty:"Загрузка платежей...",
    response_title:"Платежи",
    activo_con_previa_cancelacion: "🎮 Доступ активен (запланированная отмена)",
    fecha_cancelacion_suscripcion: "⚠️ Ваша подписка будет отменена:",
    en_proceso_cancelacion: "🟠 Подписка в процессе отмены",
    acceso_hasta: "Доступ доступен до:",
    despues_esta_fecha_no_acceso: "После этой даты доступ будет автоматически закрыт",
    suscripcion_finalizada: "💳 Подписка завершена",
    suscripcion_cancelada: "🔴 Подписка отменена",
    acceso_habiliatdo: "🟢 Доступ разрешен:",
    upgrade_plan : "Изменить план",
    modificar_a :"Изменить на:",
    tienes_el_plan_maximo: "✨ У вас максимальный тариф.",
    reactivar_suscripcion: "🔄 Возобновить подписку",
    cancelar_suscripcion: "❌ Отменить подписку",
    en_proceso: "⏳ Обработка...",
    cancelando: "⏳ Отмена...",
    cancelada: "✅ Отменено",
    error: "❌ Ошибка",
    reactivando_suscripcion: "⏳ Возобновление...",
    reactivada: "✅ Возобновлено",
    no_pagos_aun: "Платежей пока нет.",
    pagar: "💳 Оплатить",
    pagado: "💳 Оплачено",
    activar_acceso_simulador: "💳 Активировать доступ к симулятору",
    sin_suscripcion_inactiva: "🔴 Нет активной подписки",
    membresia_title: "Подписка",
credits_title: "Кредиты",
add_saldo: "Пополнить баланс",
}




}
